module.exports = __webpack_public_path__ + "static/media/imgBiz.f1cb79fa.svg";